<template>
    <div>
    <div>

      <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 border-gray-200">
          <form v-on:submit.prevent="onSubmit">
          <div class="flex justify-between">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Privacy Policy</h3>
 
                </div>
                <p class="max-w-full mt-1 text-sm leading-5 text-gray-500">
                  Inserisci i link della tua privacy policy per ciascuna lingua. Se non la possiedi, possiamo aiutarti a generarla. <a class="font-semibold text-indigo-600" href="mailto:info@menubyte.it">Contattaci</a>
                </p>

              <div class="mt-4" >
                <label for="email" class="block text-sm font-medium leading-5 text-gray-700">Link Privacy Policy
                </label>

              
              <div v-for="(language, index) in form.checked_languages" :key="'name'+language.code">
                        <div class="flex mt-1 rounded-md shadow-sm" :class="index > 0 ? 'mt-3' : ''">
                        <span class="inline-flex items-center justify-center w-10 px-2 text-center text-gray-500 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 sm:text-sm">
                          {{language.code}}
                        </span>
                        
                        <input
                        :class="tl.privacy_policyTranslationErrors[language.code] ? 'border-red-300' : ''"
                        v-model="tl.privacy_policyTranslation[language.code]"
                        :id='"language_"+language.id'
                        :name='"language_"+language.id'
                        class="flex-1 block w-full px-3 py-2 rounded-none form-input rounded-r-md sm:text-sm sm:leading-5">
                      </div>
                      <p class="mt-1 text-xs text-red-600" v-if="tl.privacy_policyTranslationErrors[language.code]">
                        {{ tl.privacy_policyTranslationErrors[language.code] }}
                      </p>
                  </div>
              </div>
 
 
          <button
                  type="submit"
                  class="inline-flex justify-center px-4 py-2 mt-8 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                >Salva</button>
                </form>
          </div>
                
      </div>
    </div>
  </div>
</template>

<script>
import PrivacyPolicy from "../apis/PrivacyPolicy";

export default {
  components: {
    
  },
  data() {
    return {
      id: this.$route.params.id,
      tl:{},
      fields:["privacy_policy"],
      formErrors: {},
      form:{ 
      }
    };
  },
  mounted() {
    PrivacyPolicy.get(this.id).then(response => {
      this.createDynamicReactive(response.data.data);
    });
  },
  created(){
  },
  methods: {

    prepareData: function() {
      this.tl.enable = this.form.enable;
      this.tl.coupon_enable = this.form.coupon_enable;
      this.tl.coupon_value = this.form.coupon_value;
      this.tl.exipred_days = this.form.exipred_days;
    },
    createDynamicReactive(data){
      for (let i = 0; i < this.fields.length; i++) {
        let obj = {};
        let objErrors = {};
        for (let j = 0; j < data.checked_languages.length; j++) {
          let code = data.checked_languages[j].code;
          obj[code] = this.getTraslation(data.translations, code, this.fields[i]);
          objErrors[code] = null;
        }
        this.$set(this.tl, this.fields[i] + "Translation", obj);
        this.$set(this.tl, this.fields[i] + "TranslationErrors", objErrors);
      }
      this.form = data;
    },
    // eslint-disable-next-line no-unused-vars
    getTraslation: function(list, code, propertyName){
      if (list === undefined || list === null){
        return "";
      }
      let result = list.filter(x => x.locale == code);
      if (result.length > 0) {
        return result[0][propertyName];
      }
      return "";
    }, 

    onSubmit: function() {
      this.removeValidationErrors();
 
        this.$store.dispatch("updateSpinner", true);
        this.prepareData();
        PrivacyPolicy.update(this.id, this.tl)
          .then(() => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Dati aggiornati", description:""});
        })
        .catch(error => {
          if (error.response.status === 422) {
              this.showValidationErrors(error.response.data.errors);
              this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Correggi gli errori", description: "", succes: false});
          }
          this.$store.dispatch("updateSpinner", false);
        });
       
    },

    removeValidationErrors: function(){
      this.formErrors = {};
      for(let j=0; j<this.form.checked_languages.length; j++){
        let code = this.form.checked_languages[j].code;
        for(let k=0; k<this.fields.length; k++){
          this.tl[this.fields[k] + 'TranslationErrors'][code] = undefined;
        }
      }
    },

    showValidationErrors: function(list){
      let keys = Object.keys(list);
      for (let i = 0; i < keys.length; i++) {
        //Errori multilingua conengono il punto
        if (keys[i].includes(".")){
          for (let j = 0; j < this.form.checked_languages.length; j++) {
            let code = this.form.checked_languages[j].code;
            for (let k = 0; k < this.fields.length; k++) {
              if (keys[i] == this.fields[k] + "Translation." + code) {
                this.tl[this.fields[k] + 'TranslationErrors'][code] = list[keys[i]][0];
              }
            }
          }
        }
      }
      this.formErrors = list;
    },
  }
};
</script>
